import {
  createApi,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react';
import { auth } from '../firebaseConfig';
import { addToast } from '@/store/slices/toastSlice';

// const customFetchBaseQuery =
//   ({ baseUrl }: { baseUrl: string }) =>
//   async (
//     {
//       url,
//       method,
//       body,
//       headers,
//       customBaseUrl,
//       onFileUpload,
//     }: {
//       url: string;
//       method: string;
//       body: any;
//       headers: Record<string, string>;
//       customBaseUrl: string;
//       onFileUpload: () => void;
//     },
//     {
//       dispatch,
//       getState,
//       extra,
//       signal,
//     }: { dispatch: any; getState: any; extra: any; signal: any }
//   ) => {
//     return new Promise((resolve, reject) => {
//       const xhr = new XMLHttpRequest();
//       xhr.withCredentials = true;
//       xhr.open(method, `${customBaseUrl || baseUrl}/${url}`, true);
//       // xhr.responseType = 'blob';

//       if (!(body instanceof FormData)) {
//         xhr.setRequestHeader('Content-Type', 'application/json');
//         body = JSON.stringify(body);
//       }

//       // Set headers if provided
//       if (headers) {
//         Object.entries(headers).forEach(([key, value]) => {
//           xhr.setRequestHeader(key as string, value as string);
//         });
//       }

//       // Listen for progress events
//       xhr.upload.onprogress = (event) => {
//         if (event.lengthComputable) {
//           const percentComplete = (event.loaded / event.total) * 100;
//           console.log(`Upload progress: ${percentComplete}%`);
//           onFileUpload && onFileUpload();
//           // Dispatch progress event if needed
//           // dispatch(uploadProgress(percentComplete));
//         }
//       };

//       // Handle the load event when the request is complete
//       xhr.onload = () => {
//         if (xhr.status >= 200 && xhr.status < 300) {
//           const contentType = xhr.getResponseHeader('Content-Type');

//           if (contentType?.includes('application/json')) {
//             // If the response is JSON, parse it
//             resolve({
//               data: JSON.parse(xhr.responseText),
//             });
//           } else {
//             resolve({
//               data: xhr.response, // Could be a blob, arrayBuffer, etc.
//             });
//           }
//         } else {
//           reject(new Error(`Upload failed with status ${xhr.status}`));
//         }
//       };

//       // Handle error
//       xhr.onerror = () => {
//         reject(new Error('Upload failed'));
//       };

//       // Send the request
//       xhr.send(body);
//     });
//   };

const dynamicBaseQuery = async (
  { url, method, body, customBaseUrl }: any,
  api: any,
  extraOptions: any
) => {
  const baseUrl = customBaseUrl || process.env.NEXT_PUBLIC_API_URL;

  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    credentials: 'include',
    prepareHeaders: async (headers) => {
      const token = await auth.currentUser?.getIdToken();
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }

      return headers;
    },
  });

  const result = await rawBaseQuery({ url, method, body }, api, extraOptions);

  if (result.error) {
    let error: string = '';

    if (typeof result.error.data === 'string') {
      error = result.error.data;
    } else if (typeof result.error.data === 'object') {
      error = JSON.stringify(result.error.data);
    }

    if (error && error.trim() !== '') {
      // api.dispatch(
      //   addToast({
      //     text: error,
      //     variant: 'danger',
      //   })
      // );
    }
  }

  return result;
};

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: dynamicBaseQuery,
  endpoints: () => ({}),
});
